import { Tile } from '../Tile';
import { Grid, Box, Bones, Text } from '@simplywallst/ui-core';

export const CompanyTileSkeleton = () => {
  return (
    <Tile>
      <Grid
        height="310px"
        padding="x1"
        paddingLeft="x1_5"
        templateColumns="100%"
        templateRows="50px auto 50px"
      >
        <Box width="80%">
          <Bones margin="x0_5" />
          <Bones margin="x0_5" maxWidth="50px" />
        </Box>
        <Grid alignItems="center" justifyContent="center" templateRows="190px">
          <Grid width={130} height={130} borderRadius="x20">
            <Bones borderRadius="x20" />
          </Grid>
        </Grid>
        <Grid
          templateColumns="0.4fr 0.3fr auto 50px"
          alignItems="flex-end"
          height="100%"
        >
          <Box>
            <Bones margin="x1" />
            <Bones margin="x1" />
          </Box>
          <Box margin="x1">
            <Text typography="xSmall" color="whiteRGBA" opacity={0.7}>
              7D
            </Text>
            <Bones />
          </Box>
          <Box margin="x1">
            <Text typography="xSmall" color="whiteRGBA" opacity={0.7}>
              1Y
            </Text>
            <Bones />
          </Box>
        </Grid>
      </Grid>
      <Box position="absolute" top={12} right={14}>
        <Grid width={35} height={35} borderRadius="x8">
          <Bones borderRadius="x8" />
        </Grid>
      </Box>
    </Tile>
  );
};
